export default __webpack_public_path__ + "static/media/phone.fa6a4f4e.png";